import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Member document interface
 */
export interface MemberDocument extends BaseDocument {
  userId: string
  isDefault: boolean
  email: string | null
  exUserId: string | null
  name: string | null
  profilePictureUrl: string | null
  role: string | null
  isSuperAgent: boolean
  lastActiveAt?: number | null
}

/**
 * Member-specific hooks
 */
const hooks = createEntityHooks<MemberDocument>('members')

export const useMembers = (filter?: Partial<MemberDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { members: data, isLoading, db }
}

export const useMember = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { member: data, isLoading }
}

export const useMemberMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createMember: create,
    updateMember: update,
    deleteMember: deleteEntity,
  }
}
